import { Component } from 'react';
import {connect} from 'react-redux';
import {verifyResetLink} from '../../../actions/login';
import NewPasswordForm from '../new-password';
import { LINK } from '../../../data/resetTypes';

class PasswordResetReceiver extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.valid === null) {
      const {id} = this.props.match.params;
      verifyResetLink({reset_password_token: id});
    }
  }

  render() {
    const { valid, area } = this.props;

    return (
      <div>
        { valid && <NewPasswordForm area={area} resetType={LINK}/> }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  valid: state.verifyResetLink.linkValid,
  errors: state.verifyResetLink.errors
});

export default connect(mapStateToProps)(PasswordResetReceiver);
